import { FlashSaleResponseDto } from '../dto/flashsale.dto';
import { environment } from '@/shared/enviroment/environment';
import { ApiService } from '@/shared/service/Apiservice';
import axios from 'axios';

class FlashSaleService {
  private apiRootServer = environment.api.apiRootServer;
  private __Apiservice: ApiService;

  constructor() {
    const axiosInstance = axios.create();
    this.__Apiservice = new ApiService(axiosInstance, this.apiRootServer);
  }

  async getFlashSales(): Promise<FlashSaleResponseDto> {
    return this.__Apiservice.getRequest('products/deal-of-the-day', {}, {
      apiRoot: this.apiRootServer,
    });
  }
}

const flashSaleService = new FlashSaleService();

export default flashSaleService;
